import React, { Suspense } from 'react';
import { Context as AuthContext } from '../Redux/context/AuthContext';
import { Switch, Route, Redirect } from 'react-router-dom';
import { blockSellerList } from '../utils/constants';
import { useSelector } from 'react-redux';

const LandingPageComponent = React.lazy(() => import('../pages/LandingPage'));
// const PaymentsHistory = React.lazy(() => import('../pages/PaymentsHistory'));
const BannerComponent = React.lazy(() => import('../pages/BannerComponent'));
const PerformanceDashboard = React.lazy(() => import('../pages/PerformanceDashboard'));
// const ReturnOrderPage = React.lazy(() => import('../pages/ReturnOrders'));
// const DealComponent = React.lazy(() => import('../pages/Deals'));
const ReverseAuction = React.lazy(() => import('../pages/ReverseAuction'));
const BulkDeals = React.lazy(() => import('../pages/BulkDeals'));
const AdminOrderPage = React.lazy(() => import('../pages/AdminOrders'));
const OrdersPage = React.lazy(() => import('../pages/orderManagement'));
// const OrdersHistoryPage = React.lazy(() => import('../pages/OrderHistory'));
const VendorDetailsPage = React.lazy(() => import('../pages/VendorDetails'));
const InventoryPage = React.lazy(() => import('../pages/Inventory'));
const Analytics = React.lazy(() => import('../pages/Analytics'));
const NotAuthorized = React.lazy(() => import('./NotAuthorized'));
const AdminAuthorized = React.lazy(() => import('../pages/AdminAuthorized'));
const TermsAndConditionPage = React.lazy(() => import('../pages/TermsAndCondition'));
const NicCredentials = React.lazy(() => import('../pages/NicCredentials'));
const Banner = React.lazy(() => import('../pages/BannerComponent/APICredentialsBanner'));
const PaymentLedger = React.lazy(() =>
  import('../pages/PaymentDashboard/OrdersPassbook/passbookComponent')
);
const PaymentsPage = React.lazy(() =>
  import('../pages/PaymentDashboard/OrdersPayments/paymentComponent')
);
const GRNComponent = React.lazy(() => import('../pages/GRN/GrnComponent'));
const AccountStatementPage = React.lazy(() => import('../pages/AccountStatement'));
const NotAuthorizedAdmin = React.lazy(() => import('./NotAuthorizedAdmin'));

// Pages
// import PaymentsPage from '../pages/Payment';
import PrivateUserJourneyRoutes from './PrivateUserJourneyRoutes';
import UserJourney from '../pages/Onboarding/Components/UserJourney';
import RecommendedProducts from '../pages/Onboarding/Components/RecommendedProducts';
// import LoginRoutes from './LoginRoutes';

const Loading = () => {
  return <div>Loading ... </div>;
};

const AuthRoutes = () => {
  const { state } = React.useContext(AuthContext);
  const { APICredentials } = useSelector((state) => state.credentials);
  const { isFalconSeller, isFalconAdmin, isFalconMaster, isFalconOps } = state.roleCheck;
  const [show, setShow] = React.useState(true);
  const auth = state.isSignedIn === true && state.tnc && state.working ? true : false;
  const showTncModal = !(state.isSignedIn === true && state.tnc);
  const loginData = localStorage.getItem('login_data')
    ? JSON.parse(localStorage.getItem('login_data'))
    : null;
  const redirectRoute =
    state.isSignedIn &&
    state.tnc &&
    state.working &&
    (isFalconSeller || isFalconAdmin || isFalconMaster || isFalconOps)
      ? '/dashboard'
      : '/login';
  return (
    <div>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route exact path={['/', '/login']}>
            {state.isSignedIn === true && state.tnc && state.working ? (
              <Redirect to={redirectRoute} />
            ) : (
              <LandingPageComponent />
            )}
          </Route>
          <Route exact path={'/admin-authorized'} component={AdminAuthorized} />
          <Route exact path="/dashboard">
            {loginData?.userJourneyCompleted || loginData?.isAdmin ? (
              <PerformanceDashboard />
            ) : (
              <UserJourney />
            )}
          </Route>
          <Route exact path="/recommended-products">
            {/* {loginData?.userJourneyCompleted ? (
            <Redirect to={redirectRoute} />
          ) : ( */}
            <RecommendedProducts />
            {/* )} */}
          </Route>
          <PrivateUserJourneyRoutes exact path="/analytics" component={Analytics} />
          <Route exact path="/my-orders" component={OrdersPage} />
          {/* <PrivateUserJourneyRoutes exact path="/orders-history" component={OrdersHistoryPage} /> */}
          <Route exact path="/catalogue" component={InventoryPage} />
          <Route exact path="/vendor-details" component={VendorDetailsPage} />
          <PrivateUserJourneyRoutes exact path="/orders" component={AdminOrderPage} />
          <PrivateUserJourneyRoutes exact path="/payments" component={PaymentsPage} />
          {/* <PrivateUserJourneyRoutes exact path="/return-orders" component={ReturnOrderPage} /> */}
          <PrivateUserJourneyRoutes exact path="/not-authorized" component={NotAuthorized} />
          {/* <PrivateUserJourneyRoutes exact path="/deals-request" component={DealComponent} /> */}
          {/* <PrivateUserJourneyRoutes exact path="/payments-history" component={PaymentLedger} /> */}
          <PrivateUserJourneyRoutes exact path="/reverse-auction" component={ReverseAuction} />
          {/* <PrivateUserJourneyRoutes exact path="/payments-history" component={PaymentsHistory} /> */}
          <PrivateUserJourneyRoutes exact path="/bulk-deals" component={BulkDeals} />
          {/* <PrivateUserJourneyRoutes exact path="/payments-history" component={PaymentsHistory} /> */}
          <PrivateUserJourneyRoutes exact path="/nic-credentials" component={NicCredentials} />
          <PrivateUserJourneyRoutes exact path="/grn" component={GRNComponent} />
          <PrivateUserJourneyRoutes
            exact
            path="/account-statement"
            component={AccountStatementPage}
          />
        </Switch>
        {auth && show ? <BannerComponent show={show} setShow={setShow} /> : null}
        {showTncModal && <TermsAndConditionPage showTerms={true} showWorkingHours={false} />}
        {APICredentials.isSaved === 0 && blockSellerList.includes(loginData.user_id) && <Banner />}
      </Suspense>
    </div>
  );
};

export default React.memo(AuthRoutes);
